import React, { useContext, useEffect, useState, useRef } from 'react';
import { systemCode, xs_languageCode } from '../../.';
import { ShopContext } from '../shop/ShopConf';
import { getConfiguration } from '../utils';
import $ from 'jquery';

export const CashoutConfigurationContext = React.createContext(null);

function CashoutConfigurationCtx(props) {
	const ctxs = useRef({}).current;
	ctxs.shopContext = useContext(ShopContext);
	
	
	const conf = getConfiguration();
    const [cashoutConfigurationContext, setCashoutConfigurationContext] = useState({
	    cashoutData : { enabled : false},
	    initialized : false,
	    fetchCashoutData : function(){
			const url = conf.api['getCashoutConfiguration'];
			if(!url){
				return;
			}
			let shopCode = null;
			if(ctxs.shopContext.enabled){
				const shopUser = ctxs.shopContext.getShopUser();  
				shopCode = shopUser? shopUser.shopCode : null;
			}
			const params = {
				systemCode,
				lingua : xs_languageCode,
				hash : '',
				shopCode
			}
			$.ajax({
	    		type: "GET",
	    		url : url,
	    		data: params,
	    		async : false,
	    		success : (response) => {
	    			const cashoutData = response? JSON.parse(response) : {};
	    			ctxs.cashoutConfigurationContext.updateContext({initialized : true, cashoutData});	
	    		},
	    		error : (errorData) => {
	    			console.log(errorData);
	    		}	
	       });
		},
		
		isCashoutEnabledForSelection : function(sportId, tournamentId, pal, avv, scomSogei, handicap, isLive){
			const cashoutData = ctxs.cashoutConfigurationContext.cashoutData;
			const sports = isLive? cashoutData.sportsLive : cashoutData.sportsPrematch;
			const tournaments = isLive? cashoutData.tournamentsLive : cashoutData.tournamentsPrematch;
			const events = isLive? cashoutData.eventsLive : cashoutData.eventsPrematch;
			const markets = isLive? cashoutData.marketsLive : cashoutData.marketsPrematch;
			const marketsForSports = isLive? cashoutData.marketsLiveForSports : cashoutData.marketsPrematchForSports;
			const marketsForTournaments = isLive? cashoutData.marketsLiveForTournaments : cashoutData.marketsPrematchForTournaments;
			
			let enabledForFirstBlock = null;
			let enabledForSecondBlock = null;
			let enabledForThirdBlock = null;
			
			//--------------- FIRST BLOCK: SPORT RESULT SET AND TOURNAMENT RESULT SET -------------------------
			
			let enabledForMarketInTournament = null;
			let enabledForMarketInSport = null;
			// MARKET SPECIFICATIONS FOR TOURNAMENT
			const marketKeyForTournament = [tournamentId, scomSogei, handicap].join('_');
			// if the market is present in this map, it means that what I find here has high priority: so enabled or not
			if(marketsForTournaments && marketsForTournaments[marketKeyForTournament] !== undefined){
				enabledForMarketInTournament = marketsForTournaments[marketKeyForTournament];
			}
			else if(handicap != 0){			
				const parametricMarketKeyForTournament = [tournamentId, scomSogei, 0].join('_');
				if(marketsForTournaments && marketsForTournaments[parametricMarketKeyForTournament] !== undefined){
					enabledForMarketInTournament = marketsForTournaments[parametricMarketKeyForTournament];
				}
			}

		
			
			// MARKET SPECIFICATIONS FOR SPORT
			const marketKeyForSport = [sportId, scomSogei, handicap].join('_');
			// if the market is present in this map, it means that what I find here has high priority: so enabled or not
			if(marketsForSports && marketsForSports[marketKeyForSport] !== undefined){
				enabledForMarketInSport = marketsForSports[marketKeyForSport];
			}
			else if(handicap != 0){
				const parametricMarketKeyForSport = [sportId, scomSogei, 0].join('_');
				if(marketsForSports && marketsForSports[parametricMarketKeyForSport] !== undefined){
					enabledForMarketInSport = marketsForSports[parametricMarketKeyForSport];
				}
			}
			
			if(enabledForMarketInTournament != null){
				enabledForFirstBlock = enabledForMarketInTournament; // something has been specified. For this block it means it has the high priority
			}
			else if(enabledForMarketInSport != null){
				enabledForFirstBlock = enabledForMarketInSport;
			}
			
			
			
			//----------------------------------------------------------------------------
			
			//--------------- SECOND BLOCK: GENERAL MARKET RESULT SET -------------------------
			
			let enabledForMarket = null; // second boolean to put in AND to get the final result
						
			if(markets && markets[scomSogei] !== undefined){
				enabledForMarket =  markets[scomSogei];
			}
			
			
			if(enabledForMarket != null){
				enabledForSecondBlock = enabledForMarket;
			}
			//-------------------------------------------------
			// if I'm here, it means that for the market block everything is still enabled for this selection. I did not found any exception
			
			
			//--------------- SECOND BLOCK: EVENT RESULT SET, TOURNAMENT RESULT SET, SPORT RESULT SET -------------------------
			
			// EVENT SPECIFICATION
			let enabledForEvent = null;
			let enabledForTournament = null;
			let enabledForSport = null;
			const eventKey = [pal, avv].join("_");
			// if the event is present in this map, it means that what I find here has high priority: so enabled or not
			if(events && events[eventKey] !== undefined){
				enabledForEvent = events[eventKey];
			}
			
			// TOURNAMENT SPECIFICATIONS
			if(tournaments && tournaments[tournamentId] !== undefined){
				enabledForTournament = tournaments[tournamentId];
			}
			
			// SPORT SPECIFICATIONS
			if(sports && sports[sportId] !== undefined){
				enabledForSport = sports[sportId];
			}
			
			if(enabledForEvent != null){
				enabledForThirdBlock = enabledForEvent;
			}
			else{
				if(enabledForTournament != null){
					enabledForThirdBlock = enabledForTournament;
				}
				else{
					if(enabledForSport != null){
						enabledForThirdBlock = enabledForSport;		
					}
				}
			}
			
			let finalResult = null;
			
			if(enabledForFirstBlock != null){
				finalResult = enabledForFirstBlock;
			}
			
			if(enabledForSecondBlock != null){
				if(finalResult == null){
					finalResult = enabledForSecondBlock;
				}
				else{
					finalResult = finalResult && enabledForSecondBlock;
				}
			}
			
			if(enabledForThirdBlock != null){
				if(finalResult == null){
					finalResult = enabledForThirdBlock;
				}
				else{
					finalResult = finalResult && enabledForThirdBlock;
				}
			}
			
			if(finalResult != null){
				return finalResult;
			}
			
			// default case
			return cashoutData.enabled;
		},
		
	    updateContext : function(updt){
			setCashoutConfigurationContext(prev => {
				return {...prev, ...updt};
            });
		}
	
    });
    
    ctxs.cashoutConfigurationContext = cashoutConfigurationContext;
    const shopUser = ctxs.shopContext.getShopUser();  
    useEffect(() => {
		
		let fetchConfiguration = !props.isVirtual && !ctxs.cashoutConfigurationContext.initialized;
		if(ctxs.shopContext.enabled){
			fetchConfiguration = fetchConfiguration && shopUser && shopUser.logged;
		}
		if(fetchConfiguration){
			ctxs.cashoutConfigurationContext.fetchCashoutData();
			ctxs.cashoutConfigurationContext.intervalId = setInterval(() => {
				ctxs.cashoutConfigurationContext.fetchCashoutData();
			}, 60000);
		}
		else {
    		clearInterval(ctxs.cashoutConfigurationContext.intervalId);
    	}
    	
    	window.isCashoutEnabledForSelection = function(sportId, tournamentId, pal, avv, scomSogei, handicap, isLive){
			return ctxs.cashoutConfigurationContext.isCashoutEnabledForSelection(sportId, tournamentId, pal, avv, scomSogei, handicap, isLive);
		}

        // Remove polling when component is unmounted
        return () => {
            clearInterval(ctxs.cashoutConfigurationContext.intervalId);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shopUser, props.isVirtual]);
    
    return (
    	<CashoutConfigurationContext.Provider value={ctxs.cashoutConfigurationContext}>
    	    {props.children}
    	</CashoutConfigurationContext.Provider>
    );
}

export default CashoutConfigurationCtx;
